/*
 * GB Mobile Header - drawer, overlay, tabs and search trigger.
 *
 * Uses event delegation on `document` so taps keep working even if this script
 * runs late on a slow, contended first load (Instagram in-app browser), and
 * every element lookup is null-guarded so a missing node can never throw and
 * kill the rest of start-up.
 */
(function () {
  function getDrawer() {
    return document.getElementById('gbmhDrawer');
  }

  function getOverlay() {
    return document.getElementById('gbmhOverlay');
  }

  function openDrawer() {
    var drawer = getDrawer();
    var overlay = getOverlay();
    if (!drawer) return;
    drawer.classList.add('gbmh__drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('gbmh__overlay--open');
    document.body.classList.add('gbmh-no-scroll');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    var overlay = getOverlay();
    if (!drawer) return;
    drawer.classList.remove('gbmh__drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('gbmh__overlay--open');
    document.body.classList.remove('gbmh-no-scroll');
  }

  function openSearch() {
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') {
      modal.showDialog();
    } else if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      window.location.href = '/search';
    }
  }

  function switchTab(tab) {
    var tabId = tab.getAttribute('data-tab');
    if (!tabId) return;

    var tabs = document.querySelectorAll('.gbmh__col-tab');
    var panels = document.querySelectorAll('.gbmh__product-panel');

    tabs.forEach(function (t) {
      t.classList.remove('gbmh__col-tab--active');
    });
    panels.forEach(function (p) {
      p.classList.remove('gbmh__product-panel--active');
    });

    tab.classList.add('gbmh__col-tab--active');
    var target = document.querySelector('.gbmh__product-panel[data-panel="' + tabId + '"]');
    if (target) target.classList.add('gbmh__product-panel--active');
  }

  // Single delegated click handler: attached once, works no matter when the
  // header markup (or this script) finishes loading.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    if (e.target.closest('#gbmhOpen') || e.target.closest('#gbmhStickyOpen')) {
      openDrawer();
      return;
    }

    if (e.target.closest('#gbmhClose') || e.target.closest('#gbmhOverlay')) {
      closeDrawer();
      return;
    }

    if (e.target.closest('#gbmhSearch')) {
      openSearch();
      return;
    }

    var tab = e.target.closest('.gbmh__col-tab');
    if (tab) switchTab(tab);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = getDrawer();
    if (drawer && drawer.classList.contains('gbmh__drawer--open')) {
      closeDrawer();
    }
  });
})();
